import { render, staticRenderFns } from "./QQlogin.vue?vue&type=template&id=15827e3d&scoped=true&"
import script from "./QQlogin.vue?vue&type=script&lang=js&"
export * from "./QQlogin.vue?vue&type=script&lang=js&"
import style0 from "./QQlogin.vue?vue&type=style&index=0&id=15827e3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15827e3d",
  null
  
)

export default component.exports